import { useMutation } from "@tanstack/react-query";
import { getChatApiClient } from "@shared/apis/sidekick/api-factories";
import { toast } from "@shared/services/toast";
import { SendSupportRequestResponse } from "@shared/apis/sidekick/generated";

type Props = {
  onSuccess?: (data: SendSupportRequestResponse) => void;
};

type Params = {
  description: string;
};

export const useSendGeneralSupportMessage = (props?: Props) => {
  const { onSuccess } = props || {};
  const chatApi = getChatApiClient();
  const mutation = useMutation({
    mutationFn: async (params: Params) => {
      const { description } = params;

      try {
        const response = await chatApi.chatControllerSendGeneralSupportRequest({
          sendGeneralSupportRequest: {
            description,
          },
        });
        onSuccess?.(response);
        // toast.success(
        //   "Thank you for your support request! We've received your message and will follow up with you via email shortly. Our team is here to assist you and will get back to you as soon as possible."
        // );
        return response;
      } catch (error) {
        console.error("Failed to send the general support request", error);
        toast.error("Failed to send the general support request");
      }
    },
    mutationKey: ["send-general-support-message"],
  });

  return mutation;
};
